import React from 'react';
import PropTypes from 'prop-types';
import ReactMarkdown from 'react-markdown';
import classNames from 'classnames';
import css from './MarkdownText.css';

const MarkdownText = ({ content, className }) => {
    if (!content) return null;

    // Escape double underscores to prevent them from being treated as bold
    const processedContent = content.replace(/__/g, '\\_\\_');

    const customRenderers = {
        paragraph: ({ children }) => <p className={css.paragraph}>{children}</p>,

        strong: ({ children }) => <strong className={css.strong}>{children}</strong>,

        emphasis: ({ children }) => <em className={css.emphasis}>{children}</em>,

        list: ({ ordered, children }) => {
            const ListTag = ordered ? 'ol' : 'ul';
            return <ListTag className={css.list}>{children}</ListTag>;
        },

        listItem: ({ children }) => <li className={css.listItem}>{children}</li>,

        code: ({ inline, children }) => {
            if (inline) {
                return <code className={css.inlineCode}>{children}</code>;
            }
            return (
                <pre className={css.codeBlock}>
                    <code>{children}</code>
                </pre>
            );
        },

        link: ({ href, children }) => (
            <a href={href} className={css.link} target="_blank" rel="noopener noreferrer">
                {children}
            </a>
        ),

        heading: ({ level, children }) => {
            const HeadingTag = `h${level}`;
            return React.createElement(HeadingTag, { className: css[`heading${level}`] }, children);
        },

        blockquote: ({ children }) => <blockquote className={css.blockquote}>{children}</blockquote>,
    };

    return (
        <div className={classNames(css.markdownText, className)}>
            <ReactMarkdown source={processedContent} renderers={customRenderers} breaks />
        </div>
    );
};

MarkdownText.propTypes = {
    content: PropTypes.string,
    className: PropTypes.string,
};

export default MarkdownText;
